import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { companyInfo, services } from '../data/mock';

const Footer = () => {
  const quickLinks = [
    { href: '#services', label: 'Services' },
    { href: '#about', label: 'About Us' },
    { href: '#gallery', label: 'Gallery' },
    { href: '#contact', label: 'Contact' },
  ];

  const topServices = services.slice(0, 6);

  return (
    <footer className="footer">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-20 w-auto mb-6"
            />
            <p className="text-white/70 mb-6">
              Professional landscaping services for residential and commercial
              properties. Over {companyInfo.yearsExperience} years of experience
              serving Georgia and Florida.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-white/70 hover:text-[#D3FF62] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-lg mb-5">Our Services</h4>
            <ul className="space-y-3">
              {topServices.map((service) => (
                <li key={service.id}>
                  <a
                    href="#services"
                    className="text-white/70 hover:text-[#D3FF62] transition-colors"
                  >
                    {service.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-5">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${companyInfo.phone}`}
                  className="flex items-start gap-3 text-white/70 hover:text-[#D3FF62] transition-colors"
                >
                  <Phone size={18} className="mt-0.5 flex-shrink-0" />
                  {companyInfo.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-start gap-3 text-white/70 hover:text-[#D3FF62] transition-colors break-all"
                >
                  <Mail size={18} className="mt-0.5 flex-shrink-0" />
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <MapPin size={18} className="mt-0.5 flex-shrink-0" />
                <div>
                  <p>{companyInfo.address}</p>
                  <p className="text-[#C5D89A] text-sm mt-1">
                    {companyInfo.serviceArea}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm text-center md:text-left">
              © {new Date().getFullYear()} {companyInfo.fullName}. All rights
              reserved.
            </p>
            <p className="text-white/60 text-sm">
              Professional Landscaping Services
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
